import { Home } from "./pages/Home";

AOS.init({
  duration: 800,
  once: true,
});

document.getElementById("app").innerHTML = Home();
window.addEventListener("scroll", () => {
  const navbar = document.querySelector(".navbar");

  if (window.scrollY > 50) {
    navbar.classList.add("navbar-scrolled");
  } else {
    navbar.classList.remove("navbar-scrolled");
  }
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(new URL("./sw.js", import.meta.url))
    .then(() => console.log("Service Worker Registered"))
    .catch((err) => console.log("SW failed", err));
}
